import { Notification as DSNotification } from '@s-group/design-system-components/Notification/Notification'
import { IconCommerceOffer, IconControlCheck, IconStatusInfo } from '@s-group/design-system-icons'
import { BodyText } from '@ui-components/typography/Typography'
import { AriaAttributes, JSX, ReactNode } from 'react'
import { styled } from 'styled-components'

import { SPACE_SMALL } from '../global/spacing'

type NotificationVariant = 'plain'
type IconType = 'no-icon' | 'default' | 'check' | 'info' | 'offer'
export type StatusVariant = 'info' | 'success' | 'warning' | 'error'

const Header = styled(BodyText)`
  color: inherit;
  p:not(:last-child) {
    margin-bottom: ${SPACE_SMALL};
  }
`

export interface NotificationProperties {
  header: ReactNode
  className?: string
  children?: ReactNode
  iconType?: IconType
  status?: StatusVariant
  variant?: NotificationVariant
  'aria-live'?: AriaAttributes['aria-live']
  trailer?: ReactNode
  id?: string
}

const getIconVariant = (iconType: IconType | undefined): JSX.Element | undefined | null => {
  switch (iconType) {
    case 'no-icon':
      return null
    case 'check':
      return <IconControlCheck />
    case 'info':
      return <IconStatusInfo />
    case 'offer':
      return <IconCommerceOffer />
    case 'default':
    default:
      return undefined
  }
}

export const Notification = ({
  className,
  children,
  iconType,
  status,
  header,
  variant = undefined,
  'aria-live': ariaLive,
  trailer,
  id,
}: NotificationProperties) => {
  return (
    <DSNotification
      id={id}
      className={className}
      close={false}
      orientation={'vertical'}
      icon={getIconVariant(iconType)}
      header={children ? header : <Header>{header}</Header>}
      status={status}
      variant={variant}
      aria-live={ariaLive}
      trailer={trailer}
    >
      {children}
    </DSNotification>
  )
}
